import React from "react";
import { addDays, getMonth, differenceInDays } from "date-fns";

class BookingCalculation extends React.Component {
  constructor(props) {
    super(props);
    this.rentalUnits = JSON.parse(props.bcWrap.dataset.rental_units);
    this.priceComposition = props.bcWrap.dataset.price_composition;
    this.priceClasses = props.bcWrap.dataset.price_classes;
    this.flatp = $("#booking_dates")[0]._flatpickr;
    this.label = props.bcWrap.dataset.label;
    this.state = {
      finalPrice: 0,
      adults: parseInt($("#booking_adults").val() || 1),
      children: parseInt($("#booking_children").val() || 0),
      appliedDiscounts: [],
      dates: this.flatp.selectedDates,
      days:
        this.flatp.selectedDates.length == 2
          ? differenceInDays(
              this.flatp.selectedDates[1],
              this.flatp.selectedDates[0]
            )
          : 0,
      selectedUnit: this.rentalUnits.find(
        (unit) => unit.id === $("#rental_unit_id").find("option:selected").val()
      ),
    };
    this.addListeners();
  }

  componentDidMount() {
    this.calculatePrice();
  }

  /**
   * Calculates final prices. Depending on type of unit, price is calculated per person or per unit.
   */
  calculatePrice() {
    let newFinalPrice = 0;

    if (
      this.state.selectedUnit.type === "SINGLE" ||
      this.state.selectedUnit.type === "SHARED"
    ) {
      const priceAdults =
        this.calculateDiscountedPrice("adults") * this.state.adults;
      const priceChildren =
        this.calculateDiscountedPrice("children") * this.state.children;
      newFinalPrice = priceAdults + priceChildren;
    } else if (
      this.state.selectedUnit.type === "APARTMENT" ||
      this.state.selectedUnit.type === "DOUBLE"
    ) {
      const persons = this.state.adults + this.state.children;
      const unitsNeeded = Math.ceil(persons / this.state.selectedUnit.capacity);
      newFinalPrice =
        this.calculateDiscountedPrice("adults") *
        this.state.selectedUnit.capacity *
        unitsNeeded;
    }

    newFinalPrice += newFinalPrice > 0 ? this.state.selectedUnit.cleaning : 0;
    this.setState({ finalPrice: newFinalPrice });
  }

  /**
   * Returns total discounted price per person.
   * Discounts do not stack. Only the highest discount is applied.
   * @param {'adults' | 'children'} category
   * @returns {number}
   */
  calculateDiscountedPrice(category) {
    if (this.state.selectedUnit.discounts.length === 0) {
      return this.state.selectedUnit.price_per_person * this.state.days;
    }

    let totalDiscountedPrice = 0;
    let appliedDiscounts = [];
    let discounts = {
      SEASON_1: 0,
      SEASON_2: 0,
      SEASON_3: 0,
      SEASON_4: 0,
      PERIOD: 0,
      REDUCTION: 0,
    };

    const period = this.state.selectedUnit.discounts.find(
      (item) => item.type === "PERIOD"
    );
    const reduction = this.state.selectedUnit.discounts.find(
      (item) => item.type === "REDUCTION"
    );
    const season1 = this.state.selectedUnit.discounts.find(
      (item) => item.type === "SEASON_1"
    );
    const season2 = this.state.selectedUnit.discounts.find(
      (item) => item.type === "SEASON_2"
    );
    const season3 = this.state.selectedUnit.discounts.find(
      (item) => item.type === "SEASON_3"
    );
    const season4 = this.state.selectedUnit.discounts.find(
      (item) => item.type === "SEASON_4"
    );

    let dateIterator = this.state.dates[0];
    while (dateIterator < this.state.dates[1]) {
      // season discount
      if (
        (season1 && getMonth(dateIterator) === 0) ||
        getMonth(dateIterator) === 1 ||
        getMonth(dateIterator) === 2
      ) {
        discounts["SEASON_1"] = season1.value;
      } else if (
        (season2 && getMonth(dateIterator) === 3) ||
        getMonth(dateIterator) === 4 ||
        getMonth(dateIterator) === 5
      ) {
        discounts["SEASON_2"] = season2.value;
      } else if (
        (season3 && getMonth(dateIterator) === 6) ||
        getMonth(dateIterator) === 7 ||
        getMonth(dateIterator) === 8
      ) {
        discounts["SEASON_3"] = season3.value;
      } else if (
        (season4 && getMonth(dateIterator) === 9) ||
        getMonth(dateIterator) === 10 ||
        getMonth(dateIterator) === 11
      ) {
        discounts["SEASON_4"] = season4.value;
      }
      // period discount
      if (period && this.state.days > 30) {
        discounts["PERIOD"] = period.value;
      }
      // child discount
      if (reduction && category === "children") {
        discounts["REDUCTION"] = reduction.value;
      }

      // find highest discount and apply if not 0
      const key = Object.keys(discounts).reduce((a, b) =>
        discounts[a] > discounts[b] ? a : b
      );
      discounts[key] !== 0 && appliedDiscounts.push(key);

      totalDiscountedPrice +=
        this.state.selectedUnit.price_per_person -
        (this.state.selectedUnit.price_per_person * discounts[key]) / 100;
      dateIterator = addDays(dateIterator, 1);
    }
    // remove duplicates in applied discounts
    appliedDiscounts = [...new Set(appliedDiscounts)];
    this.setState({ appliedDiscounts: appliedDiscounts });
    return totalDiscountedPrice;
  }

  addListeners() {
    let self = this;

    if (typeof this.flatp !== "undefined") {
      $("#booking_dates").on("change", function () {
        const newDates = $("#booking_dates")[0]._flatpickr.selectedDates;
        if (newDates.length === 2) {
          const newDays =
            newDates.length == 2
              ? differenceInDays(newDates[1], newDates[0])
              : 0;
          self.setState({ days: newDays });
          self.setState({ dates: newDates }, () => self.calculatePrice());
        }
      });
      $("#booking_adults").on("change", function () {
        const newAdults = parseInt($("#booking_adults").val() || 1);
        self.setState({ adults: newAdults }, () => self.calculatePrice());
      });
      $("#booking_children").on("change", function () {
        const newChildren = parseInt($("#booking_children").val() || 0);
        self.setState({ children: newChildren }, () => self.calculatePrice());
      });
      $("#rental_unit_id").on("change", function () {
        const newUnit = self.rentalUnits.find(
          (unit) => unit.id === $(this).find("option:selected").val()
        );
        self.setState({ selectedUnit: newUnit }, () => self.calculatePrice());
      });
    }
  }
  render() {
    if (this.state.finalPrice > 0) {
      $("#booking-calculation").removeClass("hidden");
      $("#booking-calculation-hint").removeClass("hidden");
    } else {
      $("#booking-calculation").addClass("hidden");
      $("#booking-calculation-hint").addClass("hidden");
    }

    return (
      <>
        <p className={this.priceClasses}>
          {this.label}
          <span className="price block">
            <em>
              {this.state.finalPrice != 0 &&
                amountToHuman(this.state.finalPrice)}
            </em>
            <span className="tax gray ms-1">({this.priceComposition})</span>*
          </span>
          {this.state.selectedUnit.deposit !== 0 && (
            <>
              <span className="block mb-1">
                {window.Translator.trans(
                  `units.plus.deposit`,
                  { number: amountToHuman(this.state.selectedUnit.deposit) },
                  "js"
                )}
              </span>
            </>
          )}
          {this.state.appliedDiscounts.length > 0 && (
            <>
              <span className="text strong block">
                <svg className="icon" width="12" height="12">
                  <use href="#fa-percent" />
                </svg>{" "}
                {window.Translator.trans(`units.discounts.applied`, {}, "js")}
              </span>
              {this.state.appliedDiscounts.map((discount, index) => (
                <span key={index} className="block smaller">
                  {window.Translator.trans(
                    `units.discounts.type.${discount}`,
                    {},
                    "js"
                  )}
                </span>
              ))}
            </>
          )}
        </p>
      </>
    );
  }
}

export default BookingCalculation;
